export enum UserType {
  LIFEISLIFE = 'LIFEISLIFE',
  ACCOUNTANT = 'ACCOUNTANT',
  CUSTOMER = 'CUSTOMER',
}
